import React from "react";

import { CustomSidebarItems } from "../CommonVSCode/CustomSidebarItems";

export const SidebarItems = () => {
  return <CustomSidebarItems />;
};
